import React, { useEffect } from 'react';
import { xs_languageCode } from '../..';
import { WidgetContext } from './WidgetContext';

function BetGeniusWidget(props) {
    const widgetContext = React.useContext(WidgetContext);
    
	useEffect(() => {
        const frames = document.querySelectorAll('.betgeniusWidgetGeneral');
        if (frames != null && widgetContext.widgetGeniusId != null) {
            const locale = [xs_languageCode?.toLocaleLowerCase(),xs_languageCode?.toUpperCase()].join('-')
            const url = props.url?.replace('{{FIXTURE_ID}}', widgetContext.widgetGeniusId).replace('{{LOCALE}}', locale);
            frames.forEach(function(frame) {
                frame.src = url;
            });
        }
    }, [props.url, widgetContext.widgetGeniusId]);

    return (
		<>
            <iframe title="xs-betgenius-widget" scrolling="no" className="betgeniusWidgetGeneral"></iframe>
		</>
    );
}

export default BetGeniusWidget;
